import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './DashboardPages.css';

const Home = () => {
  const { user } = useAuth();

  const stats = [
    { title: 'Total Users', value: '1,234', icon: '👥', color: '#3498db' },
    { title: 'Revenue', value: '$45,678', icon: '💰', color: '#2ecc71' },
    { title: 'Orders', value: '567', icon: '📦', color: '#e74c3c' },
    { title: 'Projects', value: '89', icon: '📋', color: '#f39c12' },
  ];

  return (
    <div className="page-container">
      <h2 className="page-title">Dashboard Overview</h2>

      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card" style={{ borderTopColor: stat.color }}>
            <div className="stat-icon" style={{ backgroundColor: stat.color }}>
              {stat.icon}
            </div>
            <div className="stat-content">
              <h3>{stat.title}</h3>
              <p className="stat-value">{stat.value}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="welcome-section">
        <h3>Welcome back, {user?.name}!</h3>
        <p>Here's what's happening with your account today.</p>
      </div>
    </div>
  );
};

export default Home;
